import React from 'react'
import TopSideBar from '../../components/TopSideBar'
import AreasListing from '../../components/AreasListing'
import { useProject } from '../../context/ProjectContext';

export default function AreasListingPage({ setBlockScreen }: any) {
  const { isProjectUndefined } = useProject();

  return <>
    <TopSideBar currentSection='areas' />

    {!isProjectUndefined() && (
      <AreasListing
        setBlockScreen={setBlockScreen}
      />
    )}
  </>
}